/**
 * Синхронизация графика строительства (ТЗ) с графиком /construction-schedule.
 */

export const normalizeWorkKey = (value) => {
  if (value == null) return '';
  return String(value).replace(/\s+/g, ' ').trim().toLowerCase();
};

/** Строка графика стройки, совпадающая по наименованию работ */
export const findConstructionSource = (tzRow, constructionSchedules) => {
  const key = normalizeWorkKey(tzRow?.work_name);
  if (!key || !Array.isArray(constructionSchedules)) return null;

  return (
    constructionSchedules.find((cs) => {
      const stageKey = normalizeWorkKey(cs.construction_stage);
      const workKey = normalizeWorkKey(cs.work_name);
      return stageKey === key || workKey === key;
    }) || null
  );
};

/** Даты и готовность для отображения: из стройки, если есть связь */
export const mergeTzConstructionRow = (tzRow, constructionSchedules) => {
  const source = findConstructionSource(tzRow, constructionSchedules);
  if (!source) {
    return { ...tzRow, isSyncedFromConstruction: false, constructionSourceId: null };
  }
  return {
    ...tzRow,
    isSyncedFromConstruction: true,
    constructionSourceId: source.id,
    planned_start_date: source.planned_start_date,
    planned_end_date: source.planned_end_date,
    actual_start_date: source.actual_start_date,
    actual_end_date: source.actual_end_date,
  };
};

export const TZ_SYNCED_ROW_BG = 'rgba(13, 110, 253, 0.1)';
export const TZ_SYNCED_ROW_BORDER = '3px solid rgba(13, 110, 253, 0.35)';

/** Поля, которые при связи со стройкой только для просмотра */
export const TZ_READONLY_WHEN_SYNCED = new Set([
  'construction_stage',
  'sections',
  'work_name',
  'planned_start_date',
  'planned_end_date',
  'actual_start_date',
  'actual_end_date',
]);

export const isTzFieldEditable = (field, isSynced) => {
  if (!isSynced) return true;
  return !TZ_READONLY_WHEN_SYNCED.has(field);
};
